module.exports = "https://redage.akamaized.net/src/views/player/help/images/capt1.jpg";